<div #exportRoot class="receipt-export-card" [ngStyle]="brandAccentStyle">
  <header class="receipt-export-card__header">
    <div class="receipt-export-card__header-top">
      <img
        *ngIf="displayLogoUrl"
        class="receipt-export-card__logo"
        [src]="displayLogoUrl"
        crossorigin="anonymous"
        alt=""
      />
      <svg
        class="receipt-export-card__check"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" fill="#16a34a" />
        <path
          d="M8 12.5L10.5 15L16 9.5"
          stroke="#ffffff"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <h1 class="receipt-export-card__title">
      {{
        (isBankSlip
          ? 'common.paymentReceipt.export.titleBankSlip'
          : 'common.paymentReceipt.export.title'
        ) | translate
      }}
    </h1>
    <p class="receipt-export-card__subtitle">
      {{
        (isBankSlip
          ? 'common.paymentReceipt.export.successSubtitleBankSlip'
          : 'common.paymentReceipt.export.successSubtitle'
        ) | translate
      }}
    </p>
  </header>

  <section class="receipt-export-card__section">
    <p class="receipt-export-card__label">
      {{
        'common.paymentReceipt.amountBreakdown.recipientReceives' | translate
      }}
    </p>
    <p class="receipt-export-card__value receipt-export-card__value--lg">
      {{ resolvedFinalAmount | currency : 'BRL' }}
    </p>
    <ng-container *ngIf="hasFee">
      <div class="receipt-export-card__row receipt-export-card__row--compact">
        <span class="receipt-export-card__row-label">
          {{ 'common.paymentReceipt.amountBreakdown.fee' | translate }}
        </span>
        <span class="receipt-export-card__row-value">
          − {{ calculatedFee | currency : 'BRL' }}
        </span>
      </div>
      <div class="receipt-export-card__row receipt-export-card__row--compact">
        <span class="receipt-export-card__row-label">
          {{ 'common.paymentReceipt.amountBreakdown.walletDebit' | translate }}
        </span>
        <span class="receipt-export-card__row-value">
          {{ resolvedRequestedAmount | currency : 'BRL' }}
        </span>
      </div>
    </ng-container>
  </section>

  <hr class="receipt-export-card__divider" />

  <section class="receipt-export-card__section" *ngIf="receipt.receiver">
    <p class="receipt-export-card__section-title">
      {{ 'features.withdrawals.modalPix.proofReceiver' | translate }}
    </p>
    <p class="receipt-export-card__muted" *ngIf="bankDisplayLine">
      {{ bankDisplayLine | uppercase }}
    </p>
    <p class="receipt-export-card__value" *ngIf="recipientDisplayName">
      {{ recipientDisplayName | uppercase }}
    </p>
  </section>

  <hr class="receipt-export-card__divider" *ngIf="receipt.receiver" />

  <section class="receipt-export-card__section">
    <p class="receipt-export-card__section-title">
      {{ 'features.withdrawals.modalPix.details' | translate }}
    </p>

    <div
      class="receipt-export-card__row"
      *ngIf="receipt.receiver?.holderDocument"
    >
      <span class="receipt-export-card__row-label">
        {{ 'features.withdrawals.modalPix.cpfCnpj' | translate }}
      </span>
      <span class="receipt-export-card__row-value">
        {{ receipt.receiver?.holderDocument | document }}
      </span>
    </div>

    <div class="receipt-export-card__row" *ngIf="agencyDisplay">
      <span class="receipt-export-card__row-label">
        {{ 'features.withdrawals.modalPix.agency' | translate }}
      </span>
      <span class="receipt-export-card__row-value">{{ agencyDisplay }}</span>
    </div>

    <div class="receipt-export-card__row" *ngIf="accountDisplay">
      <span class="receipt-export-card__row-label">
        {{ 'features.withdrawals.modalPix.checkingAccount' | translate }}
      </span>
      <span class="receipt-export-card__row-value">{{ accountDisplay }}</span>
    </div>

    <div class="receipt-export-card__row" *ngIf="digitableLine">
      <span class="receipt-export-card__row-label">
        {{ 'common.paymentReceipt.digitableLine' | translate }}
      </span>
      <span
        class="receipt-export-card__row-value receipt-export-card__row-value--break"
      >
        {{ digitableLine }}
      </span>
    </div>

    <div class="receipt-export-card__row" *ngIf="receipt.payer?.holderName">
      <span class="receipt-export-card__row-label">
        {{ 'features.withdrawals.modalPix.proofPayer' | translate }}
      </span>
      <span class="receipt-export-card__row-value">
        {{ receipt.payer?.holderName }}
      </span>
    </div>

    <div class="receipt-export-card__row" *ngIf="receipt.payer?.holderDocument">
      <span class="receipt-export-card__row-label">
        {{ 'features.withdrawals.modalPix.cpfCnpj' | translate }}
      </span>
      <span class="receipt-export-card__row-value">
        {{ receipt.payer?.holderDocument | document }}
      </span>
    </div>

    <div class="receipt-export-card__row" *ngIf="receipt.id">
      <span class="receipt-export-card__row-label">
        {{ 'features.withdrawals.modalPix.proofTransactionId' | translate }}
      </span>
      <span
        class="receipt-export-card__row-value receipt-export-card__row-value--break"
      >
        {{ receipt.id }}
      </span>
    </div>

    <div class="receipt-export-card__row" *ngIf="receipt.e2eId">
      <span class="receipt-export-card__row-label">
        {{ 'features.withdrawals.modalPix.proofE2eId' | translate }}
      </span>
      <span
        class="receipt-export-card__row-value receipt-export-card__row-value--break"
      >
        {{ receipt.e2eId }}
      </span>
    </div>
  </section>

  <hr class="receipt-export-card__divider" />

  <section class="receipt-export-card__section receipt-export-card__meta">
    <div class="receipt-export-card__meta-item">
      <p class="receipt-export-card__label">
        {{ 'features.withdrawals.modalPix.proofVia' | translate }}
      </p>
      <p class="receipt-export-card__value">
        <ng-container *ngIf="isBankSlip; else pixMethod">
          {{ 'features.withdrawals.modalBankSlip.proofMethod' | translate }}
        </ng-container>
        <ng-template #pixMethod>
          {{ 'features.withdrawals.modalPix.proofMethodPix' | translate }}
        </ng-template>
      </p>
    </div>
    <div class="receipt-export-card__meta-item" *ngIf="providerLabel">
      <p class="receipt-export-card__label">
        {{ 'features.withdrawals.modalPix.provider' | translate }}
      </p>
      <p class="receipt-export-card__value">{{ providerLabel }}</p>
    </div>
    <div class="receipt-export-card__meta-item">
      <p class="receipt-export-card__label">
        {{ 'features.withdrawals.modalPix.proofFrequency' | translate }}
      </p>
      <p class="receipt-export-card__value">
        {{
          'features.withdrawals.modalPix.proofFrequencyImmediate' | translate
        }}
      </p>
    </div>
    <div class="receipt-export-card__meta-item" *ngIf="receipt.date">
      <p class="receipt-export-card__label">
        {{ 'features.withdrawals.modalPix.proofWillReceive' | translate }}
      </p>
      <p class="receipt-export-card__value">
        {{ receipt.date | date : 'dd MMM yyyy' : '' : 'pt-BR' | uppercase }}
      </p>
    </div>
  </section>

  <footer class="receipt-export-card__footer">
    <p class="receipt-export-card__footer-text">
      {{
        'common.paymentReceipt.export.generatedAt'
          | translate
            : {
                date:
                  (receipt.date | date : 'dd/MM/yyyy HH:mm' : '' : 'pt-BR') ||
                  ''
              }
      }}
    </p>
    <p class="receipt-export-card__footer-text" *ngIf="domainTitle">
      {{ domainTitle }}
    </p>
  </footer>
</div>
